import { useQuery } from '@tanstack/react-query';

import { SuggestedPersonView } from '@ndvr/customer-api';

import { CustomerApi } from 'API';

export const SuggestedPersonQueryKeys = {
    byNote: (noteGUID: string) => ['SuggestedPeople', noteGUID] as const,
} as const;

// Endpoint plus the by-note query it makes stale, so every dismiss caller invalidates the same key.
export const suggestedPersonDismissal = (suggestedPersonGUID: string, noteGUID: string) => ({
    request: () => CustomerApi().dismissSuggestedPerson(suggestedPersonGUID),
    staleQueryKey: SuggestedPersonQueryKeys.byNote(noteGUID),
});

export const useSuggestedPeopleByNoteQuery = <TData = SuggestedPersonView[]>(
    noteGUID: string,
    options?: { select?: (suggestions: SuggestedPersonView[]) => TData },
) =>
    useQuery<SuggestedPersonView[], Error, TData>({
        enabled: !!noteGUID,
        queryKey: SuggestedPersonQueryKeys.byNote(noteGUID),
        queryFn: async () => {
            const [response] = await CustomerApi().getSuggestedPeopleByNoteGUID({ noteGUID });
            return response ?? [];
        },
        ...options,
    });
